module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    ref: "nav",
    staticClass: "section-nav",
    class: _vm.rootClasses
  }, [_c('div', {
    staticClass: "section-nav--displacer"
  }, [(_vm.isVisible) ? _c('div', {
    staticClass: "section-nav--root",
    style: (_vm.listStyles)
  }, [(_vm.titleSection) ? _c('cmp-accordion', {
    attrs: {
      "is-active": _vm.isFreeFloating || _vm.isAffixedBottom,
      "passive-mode": true
    }
  }, [_c('div', {
    staticClass: "section-nav--title",
    attrs: {
      "slot": "body"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.titleSection.title)
    },
    slot: "body"
  })]) : _vm._e(), _vm._v(" "), _c('ol', {
    staticClass: "u-reset section-nav--items"
  }, _vm._l((_vm.sortedSections), function(section, sectionIdx) {
    return _c('li', {
      staticClass: "section-nav--item",
      class: _vm.activePosition === section.position ? (_vm.bemRoot + '--item__is-active') : ''
    }, [_c('a', {
      staticClass: "u-reset section-nav--anchor-link",
      attrs: {
        "href": '#' + section.content.anchor
      }
    }, [_c('span', {
      staticClass: "section-nav--text",
      domProps: {
        "textContent": _vm._s(section.content.menu_title)
      }
    }), _vm._v(" "), _vm._m(0, true)])])
  }))], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "section-nav--rail"
  }, [_c('span', {
    staticClass: "section-nav--bg"
  }, [_c('span', {
    staticClass: "section-nav--bullet"
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7c09c2fc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c09c2fc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/section-nav/index.vue
// module id = 567
// module chunks = 7